module.exports = __webpack_public_path__ + "img/battery.ac9aadba.webp";